import { makeStyles } from 'tss-react/mui';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: '1344px',
    width: 'calc(100% - 48px)',
    margin: '0 auto',

    [theme.breakpoints.down(Breakpoint.Lg)]: {
      width: 'calc(100% - 30px)',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      minWidth: '280px',
      // Longhand so a consumer's vertical `paddingTop/Bottom` isn't reset by a
      // `padding` shorthand collision (and vice versa).
      paddingLeft: 16,
      paddingRight: 16,
      width: '100%',
    },
  },
}));

export default useStyles;
